import { useTheme } from '@mui/material';
import type { Theme } from '@mui/material/styles';
import type { ComponentTokensShape } from '../assets/global/componentTokens';

export type L2DPalette = Theme['palette'] & ComponentTokensShape;

/**
 * The MUI Theme extended with L2D component tokens.
 * `palette` is augmented to include `chip`, `icon`, `button`, `status`.
 */
export type L2DTheme = Omit<Theme, 'palette'> & {
    palette: L2DPalette;
};

/**
 * Drop-in replacement for MUI's `useTheme` that guarantees access to custom
 * palette tokens (chip, icon, button, status) defined in the L2D design system.
 *
 * Use this instead of `useTheme` from `@mui/material` whenever you need to
 * access `palette.chip`, `palette.icon`, `palette.button` or `palette.status`.
 */
export const useL2DTheme = (): L2DTheme => useTheme<Theme>() as unknown as L2DTheme;
